import { useMemo } from "react";
import { CheckoutTranslation } from "@swo/storefront";
import { ctpAddressToInternalAddress, emptyInternalAddressFactory, InternalAddress } from "./address";
import { getFormFields } from "./getFormFields";
import {
  ClientCartAddress_Second,
  SwarovskiOptikLocaleFrontend,
  SwarovskiOptikShopLocaleFrontend,
} from "@swo/storefront";
import { useEqualState } from "../../../../../../../hooks";
import { Translated } from "../../../../../../../domain/translations/translations";
import { AddressFormMode } from "./address-form-mode";

export function useAddressForm<Address extends ClientCartAddress_Second>(
  initialAddress: Address | undefined,
  translations: Translated<CheckoutTranslation>,
  locale: SwarovskiOptikShopLocaleFrontend,
  mode: AddressFormMode,
  onChangeCountryRequested: (countryIsoCode: string) => void,
  countries: Array<SwarovskiOptikShopLocaleFrontend> | null,
) {
  const [formState, setFormState] = useEqualState(
    getInitialState(initialAddress, locale.country, mode !== "billing-logged-in"),
  );

  const textFields = useMemo(
    () => getFormFields(setFormState, translations, locale, mode, onChangeCountryRequested, countries),
    [locale.country.isoCode, mode],
  );

  return [textFields, formState] as const;
}

function getInitialState(
  currentCommerceToolsAddress:
    | (ClientCartAddress_Second & { email?: string /* only for shipping address */ })
    | undefined,
  country: { isoCode: string; label: string },
  canEditUserEmail: boolean,
): InternalAddress {
  return currentCommerceToolsAddress
    ? ctpAddressToInternalAddress(currentCommerceToolsAddress, country, canEditUserEmail)
    : emptyInternalAddressFactory(country, canEditUserEmail);
}
